import * as React from 'react';
import { Box, Card, FlexGrid } from '@alinta-digital/asg';
import * as icons from '@alinta-digital/asg/icons/';
import { ActionableFuelSite } from '../../types';
import { StyledFlexGridContainer, StyledFlexGridItem } from './PlanTile.styled';
import { capitalizeFirstLetter } from '../../utils/utils';

interface PlanTileProps {
  fuelSites: ActionableFuelSite[];
}

function sortFuelSites(fuelSites: ActionableFuelSite[]): ActionableFuelSite[] {
  const result: ActionableFuelSite[] = [];
  for (const site of fuelSites) {
    if (site.fuelType === 'electricity') {
      result.push({ ...site });
    }
  }

  fuelSites
    .filter((site: ActionableFuelSite) => site.fuelType === 'gas')
    .forEach((gasSite: ActionableFuelSite) => {
      result.push({ ...gasSite });
    });

  return result;
}

export const PlanTile = (props: PlanTileProps) => {
  const { fuelSites } = props;
  const sortedSiteData = sortFuelSites(fuelSites);
  const totalRows = sortedSiteData.length;
  const lastRowIndexes = totalRows % 2 === 0 ? totalRows - 2 : totalRows - 1;

  return (
    <Box>
      <StyledFlexGridContainer>
        <FlexGrid direction="row">
          {sortedSiteData.map((site, idx) => {
            return (
              <StyledFlexGridItem
                key={idx}
                className={idx >= lastRowIndexes ? 'lastRow' : undefined}
                sm={12}
                md={6}
                margin={{ bottom: 'xsmall' }}
              >
                <Card
                  id={site.accountNumber}
                  checkboxCard={true}
                  icon={{
                    icon:
                      site.fuelType === 'electricity'
                        ? icons.LightBulb
                        : icons.Fire,
                  }}
                  text={capitalizeFirstLetter(site.label)}
                  action={site.onClick}
                  checked={site.checked}
                />
              </StyledFlexGridItem>
            );
          })}
        </FlexGrid>
      </StyledFlexGridContainer>
    </Box>
  );
};
